import { render, staticRenderFns } from "./order_detail_archive.vue?vue&type=template&id=40e86e31&scoped=true"
import script from "./order_detail_archive.vue?vue&type=script&lang=js"
export * from "./order_detail_archive.vue?vue&type=script&lang=js"
import style0 from "./order_detail_archive.vue?vue&type=style&index=0&id=40e86e31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e86e31",
  null
  
)

export default component.exports